var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-container',[_c('el-header',{staticClass:"navbar"},[_c('TheNavbar',{on:{"refresh":_vm.refreshToken}})],1),_c('el-container',[(_vm.isApp)?_c('TheSidebar'):_vm._e(),_c('TheContent',{attrs:{"sidebar":_vm.isApp}})],1)],1),(_vm.isApp)?_c('Refresh',{ref:"refresh"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }